export default "__VITE_ASSET__CBItzhRd__"